import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'shared-filter-chip',
  templateUrl: './filter-chip.component.html',
  styleUrls: ['./filter-chip.component.scss'],
  host: { class: 'shared-filter-chip' },
})
export class SharedFilterChipComponent {
  @Input() icon!: string;
  @Input() caption!: string;
  @Input() selected = true;
  @Input() disabled = false;
  @HostBinding('class.disabled') get disabledChecker() {
    return this.disabled == true;
  }
  @HostBinding('class.selected') get selectedChecker() {
    return this.selected == true;
  }
  @HostBinding('class.un-selected') get unselectedChecker() {
    return this.selected == false;
  }

  public replace(input: string, find: string, replace: string): string {
    return input.replace(find, replace);
  }
}
